import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return CreateResponsiveStyle(
    {
      containerStyle: {
        marginBottom: 24,
        width: width - 32,
      },
      titleContainerStyle: {
        marginBottom: 4,
        fontSize: 14,
        lineHeight: 22,
        color: colors.primaryTextColor,
        ...typography.mulishRegular,
      },
      timeContainerStyle: {
        paddingVertical: 20,
        paddingHorizontal: 16,
        backgroundColor: colors.white,
        borderRadius: 10,
        shadowColor: colors.black,
        shadowOffset: {
          width: 2,
          height: 1,
        },
        shadowOpacity: 0.15,
        shadowRadius: 2.24,

        elevation: 3,
      },
      timeCellContainerStyle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginVertical: 5,
      },
      timeTextStyle: {
        fontSize: 16,
        lineHeight: 26.4,
        color: colors.cornflowerBlue,
        ...typography.interMedium,
      },
      deleteTimeButtonStyle: {
        padding: 5,
      },
      deleteIconStyle: {},
      greyBorderStyle: {
        width: '100%',
        height: 1,
        marginVertical: 7,
        backgroundColor: colors.lightGrey,
      },
      addTimeButtonStyle: {
        flexDirection: 'row',
        alignItems: 'center',
      },
      addIconStyle: {},
      addTimeButtonLabelStyle: {
        marginLeft: 13,
        fontSize: 16,
        lineHeight: 24,
        color: colors.cornflowerBlue,
        ...typography.interMedium,
      },
      ...Platform.select({
        web: {
          containerStyle: {
            flexDirection: 'row',
            alignItems: 'center',

            width: width - 32,
            zIndex: 10,
            borderBottomWidth: 1,
            borderColor: colors.grey300,
          },
          titleContainerStyle: {
            marginBottom: 0,
            marginRight: 15,
            width: 80,
          },
          timeContainerStyle: {
            alignItems: 'center',
            marginVertical: 5,
            paddingVertical: 0,
            paddingHorizontal: 0,
            backgroundColor: '',
            borderRadius: 0,
            shadowColor: '',
          },
          deleteTimeButtonStyle: {
            marginLeft: 22.5,
            width: 15,
            height: 17,
          },
          addTimeButtonStyle: {
            position: 'absolute',
            bottom: 22,
            right: -70,
          },
          addIconStyle: {
            width: 15,
            height: 15,
          },
          deleteIconStyle: {
            width: 15,
            height: 16.7,
          },
        },
      }),
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        containerStyle: {
          flexDirection: 'row',
          alignItems: 'baseline',
          marginLeft: 100,
          width: 320,
          zIndex: 10,
          borderBottomWidth: 1,
          borderColor: colors.grey300,
        },
        titleContainerStyle: {
          marginBottom: 0,
          marginRight: 15,
          width: 80,
        },
        timeContainerStyle: {
          marginVertical: 5,
          paddingVertical: 0,
          paddingHorizontal: 0,
          backgroundColor: '',
          borderRadius: 0,
          shadowColor: '',
        },
        timeCellContainerStyle: {},
        deleteTimeButtonStyle: {
          marginLeft: 22.5,
        },
        addTimeButtonStyle: {},
      },
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {
        containerStyle: {
          marginLeft: 140,
          width: 502,
        },
        titleContainerStyle: {},
        timeContainerStyle: {},
      },
    },
  )();
};
